/**
 * Экспорт компонентов строки таблицы
 */

export { TableRow } from "./TableRow";
